import { createFileRoute } from "@tanstack/react-router";
import LighthouseAuditPage from "@/pages/LighthouseAuditPage";

export const Route = createFileRoute("/tools/lighthouse-audit")({
  component: LighthouseAuditPage,
});
